import { BoardCardType } from "@fry/boards/lib";
import { ProfileViewCardComponent } from "./profile-card.view.component";
import { TitleCardSettingsComponent } from "@fry/dashboards/components/card-title-settings/title-card.settings.component";

export const ProfileCard: BoardCardType = {
    name: 'profile',
    title: $localize `Profile`,
    viewComponent: ProfileViewCardComponent,
    editComponent: TitleCardSettingsComponent,
}
